import { useGetAllCarInfoQuery } from "../../utils/carInfo.utils";
import { useGetAllCarInfoTypeQuery } from "../../utils/carInfoType.utils";
import { RenderFields, optionGen } from "../../utils/form.utils";

export default function CarInfoParentField({ watch, control, errors }) {
  const type = watch("parent_type");

  const typeId = type?.value ?? "";

  const { loading: typeLoading, data: typeData } = useGetAllCarInfoTypeQuery({
    query: ``,
    key: `CarInfoParentFieldType`
  });

  const { isLoading: loading, data } = useGetAllCarInfoQuery({
    query: `?type=${typeId}`,
    options: {
      enabled: !!typeId
    },
    key: "CarInfoParentField"
  });

  const parentOptions = data?.length ? optionGen(data) : [];
  const parentTypeOptions = typeData?.length ? optionGen(typeData) : [];

  const fields = [
    {
      label: "Parent Type",
      name: "parent_type",
      type: "select",
      placeholder: "Select a parent type",
      col: { md: 12 },
      options: parentTypeOptions
    },
    {
      label: "Parent",
      name: "parent",
      type: "select",
      placeholder: "Select a parent",
      col: { md: 12 },
      options: parentOptions
    }
  ];

  const isLoading = loading || typeLoading;

  return (
    <>
      {isLoading && "Loading..."}
      {<RenderFields fields={fields} control={control} watch={watch} errors={errors} />}
    </>
  );
}
